var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-container"},[_c('div',{staticClass:"actions"},[_c('button',{class:{'show':_vm.showButton},on:{"click":_vm.submitProduct}},[_vm._v("Potvrdit výběr a objednat")])])])}
var staticRenderFns = []

export { render, staticRenderFns }